import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withQuery from '../withQuery';
import composes from '../../utils/composes';
import CurrentUserActions, {
  getCurrentUser,
} from '../../../redux-modules/current-user';
import CustomerActions, { getCustomer } from '../../../redux-modules/customers';
import OrganizationActions, {
  getOrgWithMemberStatus,
} from '../../../redux-modules/organizations';

const withCustomerOrg = ComposedComponent => {
  return class withCustomerOrg extends React.Component {
    static propTypes = {
      currentUser: PropTypes.shape({
        id: PropTypes.string,
        customer: PropTypes.object,
      }),
      currentCustomer: PropTypes.object,
      wcoActions: PropTypes.shape({
        customer: PropTypes.object,
        organization: PropTypes.object,
      }),
    };
    static promises = {
      includePromises: [
        {
          meta: { namespace: 'customers' },
        },
        {
          meta: { namespace: 'organizations' },
        },
      ],
    };

    componentDidMount() {
      this.getCustomerOrgDetails(this.props);
    }

    componentWillReceieveProps(nextProps) {
      this.getCustomerOrgDetails(nextProps);
    }

    getCustomerOrgDetails = ({
      currentCustomer,
      currentUser,
      location: { query = {} } = {},
      wcoActions,
    }) => {
      const { id, settings = {} } = currentUser || {};
      if (!currentCustomer && (!!id || (!!query.email || !!settings.email))) {
        wcoActions.customer
          .get(id || '', {
            params: { email: query.email || settings.email },
          })
          .then(custResult => {
            if (
              custResult &&
              custResult.hasError &&
              custResult.status &&
              (custResult.status >= 500 && custResult.status < 600)
            ) {
              return this.setState({ serviceError: true });
            }
            if (custResult && !custResult.hasError) {
              const { payload: { json: customer } } = custResult;
              const { key } = customer.organization || {};
              // if you don't have a currentUser, but we loaded a user
              // ensure we update the current user with a valid use
              if (!id) {
                wcoActions.currentUser.setId(customer.key);
              }
              if (!!key) {
                wcoActions.organization.get(key);
              }
            }
          });
      }
    };

    render() {
      const { wcoActions, ...props } = this.props;
      return <ComposedComponent {...props} />;
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const currentUser = getCurrentUser(state);
  let currentCustomer;
  if (ownProps.location.query.email) {
    const customerList = Object.values((state.entities || {}).customers || {});
    currentCustomer = customerList.find(
      customer =>
        (customer.contactDetails || {}).emailAddress ||
        '' === ownProps.location.query.email
    );
  } else if (currentUser.id) {
    currentCustomer = getCustomer(state, { id: currentUser.id });
  }

  return {
    currentUser,
    currentCustomer: currentCustomer
      ? {
          ...currentCustomer,
          organization:
            currentCustomer && currentCustomer.organization
              ? getOrgWithMemberStatus(state, {
                  id: currentCustomer.organization.key,
                })
              : null,
        }
      : null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    wcoActions: {
      currentUser: bindActionCreators(CurrentUserActions, dispatch),
      customer: bindActionCreators(CustomerActions, dispatch),
      organization: bindActionCreators(OrganizationActions, dispatch),
    },
  };
};

export default (...args) => {
  return composes(
    connect(mapStateToProps, mapDispatchToProps)(withCustomerOrg(...args)),
    withQuery
  );
};



// WEBPACK FOOTER //
// ./src/common/components/withCustomerOrg/index.js